import script from "./ViewASupervisorGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewASupervisorGroup.vue?vue&type=script&setup=true&lang=js"

import "./ViewASupervisorGroup.vue?vue&type=style&index=0&id=6d18927d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d18927d"]])

export default __exports__